import { customFieldsActions } from "@nextories/vue-core-components/src/store/common";
import type {Lock, PostSlot} from "@/types/Meeting";

export const pluginMeetingStore = {
  state: {
    connector: "customerAppConnector",
    granularity: 15,
    duration: 0,
    description: '',
    meetingDate: '',
    lock: {},
    locks: [],
    operators: [],
  },
  actions: {
    ...customFieldsActions,
    deleteLock(request: string, data: {
      duration: number,
    }, keepLoading: boolean) {
      this.isDataSaving = true;
      return window.customerAppConnector
        .deleteLock(request, data)
        .then(() => {
          this.lock = {};
          this.locks = [];
          this.dataError = false;
        })
        .catch((error: { error: string }) => {
          this.lock = {};
          this.dataError = true;
          throw new Error(error.error);
        })
        .finally(() => {
          this.isDataSaving = keepLoading;
        });
    },
    postLock(request: PostSlot, lock: {}, keepLoading: boolean) {
      this.isDataSaving = true;
      return window.customerAppConnector
        .postLock(request)
        .then((response: {
          locks: Lock[],
        }) => {
          this.lock = {
            ...lock,
          };
          this.locks = (response && response.locks.map((lock: Lock) => ({
            ...request,
            ...lock,
          }))) || [];
          this.dataError = false;
        })
        .catch((error: { error: string }) => {
          this.dataError = true;
          throw new Error(error.error);
        })
        .finally(() => {
          this.isDataSaving = keepLoading;
        });
    },
  },
};
